import {AdminRole, ROOT} from './../middleware/roles'


export const AdminRoutes = {
    path: '/admin',
    name: 'admin',
    meta: {hasAcces: AdminRole},
    // route level code-splitting
    // this generates a separate chunk (admin.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "admin" */ '../../views/Admin.vue'),
}